/**
 * Sélecteurs pour la gestion du token
 * @category Store
 * @hideconstructor
 */
class TokenStoreSelector {
  /**
   * Sélection de l'objet contenant les informations du token
   * @param {object} state state de l'application
   * @returns {TokenObject} Informations de session
   */
  static selectToken(state) {
    return state.manageToken.token;
  }

  /**
   * Sélection de la date et heure de la récupération du token
   * @param {object} state state de l'application
   * @returns {date} Variable contenant la date et heure de la récupération du token
   */
  static selectTokenDate(state) {
    if (!TokenStoreSelector.selectToken(state)) {
      return null;
    }

    return TokenStoreSelector.selectToken(state).date;
  }

  /**
   * Sélection du token
   * @param {object} state state de l'application
   * @returns {string} Variable contenant le token
   */
  static selectTokenValue(state) {
    if (!TokenStoreSelector.selectToken(state)) {
      return null;
    }

    return TokenStoreSelector.selectToken(state).token;
  }

}

/**
 * Sélecteurs pour la gestion du token admin
 * @category Store
 * @hideconstructor
 */
class TokenAdminStoreSelector {
  /**
   * Sélection de l'objet contenant les informations du token
   * @param {object} state state de l'application
   * @returns {TokenAdminObject} Informations de session
   */
  static selectTokenAdmin(state) {
    return state.manageToken.tokenAdmin;
  }

  /**
   * Sélection de la date et heure de la récupération du tokenAdmin
   * @param {object} state state de l'application
   * @returns {date} Variable contenant la date et heure de la récupération du tokenAdmin
   */
  static selectTokenAdminDate(state) {
    if (!TokenAdminStoreSelector.selectTokenAdmin(state)) {
      return null;
    }

    return TokenAdminStoreSelector.selectTokenAdmin(state).date;
  }

  /**
   * Sélection du tokenAdmin
   * @param {object} state state de l'application
   * @returns {string} Variable contenant le tokenAdmin
   */
  static selectTokenAdminValue(state) {
    if (!TokenAdminStoreSelector.selectTokenAdmin(state)) {
      return null;
    }

    return TokenAdminStoreSelector.selectTokenAdmin(state).tokenAdmin;
  }

}

/**
 * Sélecteurs pour la gestion de la version
 * @category Version
 * @hideconstructor
 */
class VersionStoreSelector {
  /**
   * Sélection de l'objet contenant les informations de la version de l'application
   * @param {object} state state de l'application
   * @returns {VersionObject} Informations de la version
   */
  static selectVersion(state) {

    return state.manageVersion.version;
  }

  /**
  * Sélection de la date et heure de la récupération du tokenAdmin
  * @param {object} state state de l'application
  * @returns {date} Variable contenant la date et heure de la récupération du tokenAdmin
  */
  static selectVersionApp(state) {
    if (!VersionStoreSelector.selectVersion(state)) {
      return null;
    }

    return VersionStoreSelector.selectVersion(state).version;
  }
}

/**
 * Sélecteurs pour la gestion du token
 * @category Store
 * @hideconstructor
*/
class UserStoreSelector {
  /**
   * Sélection de l'objet contenant les informations de l'utilisateur
   * @param {object} state state de l'application
   * @returns {TokenObject} Informations de session
   */
  static selectUser(state) {
    return state.manageUser.user;
  }

  /**
   * Sélection du token
   * @param {object} state state de l'application
   * @returns {string} Variable contenant l'email de l'utilisateur
   */
  static selectUserEmail(state) {
    return UserStoreSelector.selectUser(state).email;
  }
  /**
   * Sélection du token
   * @param {object} state state de l'application
   * @returns {string} Variable contenant le token
   */
  static selectUserId(state) {
    return UserStoreSelector.selectUser(state).id;
  }
  /**
   * Sélection du token
   * @param {object} state state de l'application
   * @returns {string} Variable contenant la plaque d'immatriculation de l'utilisateur
   */
  static selectUserPlate(state) {
    return UserStoreSelector.selectUser(state).plate;
  }
  /**
   * Sélection du token
   * @param {object} state state de l'application
   * @returns {string} Variable contenant le nom de l'utilisateur
   */
  static selectUserUsername(state) {
    return UserStoreSelector.selectUser(state).username;
  }

}

export const selectToken = TokenStoreSelector.selectToken;
export const selectTokenDate = TokenStoreSelector.selectTokenDate;
export const selectTokenValue = TokenStoreSelector.selectTokenValue;
export const selectTokenAdmin = TokenAdminStoreSelector.selectTokenAdmin;
export const selectTokenAdminDate = TokenAdminStoreSelector.selectTokenAdminDate;
export const selectTokenAdminValue = TokenAdminStoreSelector.selectTokenAdminValue;
export const selectUser = UserStoreSelector.selectUser;
export const selectUserEmail = UserStoreSelector.selectUserEmail;
export const selectUserId = UserStoreSelector.selectUserId;
export const selectUserPlate = UserStoreSelector.selectUserPlate;
export const selectUserUsername = UserStoreSelector.selectUserUsername;
export const selectVersion = VersionStoreSelector.selectVersion;
export const selectVersionApp = VersionStoreSelector.selectVersionApp;
